import { defineMessages } from 'react-intl'

const messages = {
    labeledProductsInCycle: {
        id: 'app.components.simple-cycle.labels',
        defaultMessage: `{labels, number} {labels, plural,
      one {Label}
      other {Labels}
    }`,
    },
    openOrdersInCycle: {
        id: 'app.components.simple-cycle.orders',
        defaultMessage: `{orders, number} {orders, plural,
      one {Open order}
      other {Open orders}
    }`,
    },
    today: {
        id: 'app.components.simple-cycle.today',
        defaultMessage: '{date}, Today',
    },
    NA: {
        id: 'app.components.simple-cycle.NA',
        defaultMessage: 'N/A',
    },
}

export default defineMessages(messages)
